import React, { useEffect, useState } from 'react'
import Skill from '../components/skills/Skill'
//import skillsData from '../data/skills'
import { motion } from 'framer-motion';
import CloseButton from '../components/common/CloseButton'
import { request } from 'graphql-request'

const Skills = () => {

    const [skillsData, setSkillsData] = useState([])

    useEffect(() => {
        const fetchSkills = async () => {
            const { skillsData } = await request(process.env.REACT_APP_API_URL, `{
                skillsData(first: 50 ){
                    id
                    name
                    level
                    type
                    image {
                        url(transformation: {image: {resize: {}}, document: {output: {}}})
                    }
                  }
            }`
            );
            setSkillsData(skillsData);
            console.log(skillsData)

        }
        fetchSkills();

    }, [])

    // console.log(skills)


    return (
        <motion.div
            className='h-full'
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ duration: 0.4 }}
        >
            <div className='bg-white dark:bg-gray-900 p-5 rounded-custom z-40'>
                <div className='flex justify-between items-center'>
                    <h4 className='text-center font-bold text-4xl text-slate-900 dark:text-white tracking-wide uppercase'>My <span className='text-skin-base'>skills</span></h4>
                    <CloseButton />
                </div>
                <div className='h-[calc(100vh-130px)] md:h-[calc(100vh-155px)] overflow-y-auto mt-4'>

                    <div className='grid grid-cols-1 md:grid-cols-2 gap-5 '>
                        <div className='w-full'>
                            <h3 className='text-2xl font-semibold text-slate-900 dark:text-white mb-3'>Databases</h3>
                            <div className='flex flex-wrap justify-start items-center gap-3'>
                                {
                                    skillsData.filter(data => data.type === 'language').map((item, i) =>
                                        <Skill item={item} key={i} />
                                    )
                                }
                            </div>
                        </div>
                        <div className='w-full'>
                            <h3 className='text-2xl font-semibold text-slate-900 dark:text-white mb-3'>Databases</h3>
                            <div className='flex flex-wrap justify-start items-center gap-3'>
                                {
                                    skillsData.filter(data => data.type === 'database').map((item, i) =>
                                        <Skill item={item} key={i} />
                                    )
                                }
                            </div>
                        </div>
                        <div className='w-full'>
                            <h3 className='text-2xl font-semibold text-slate-900 dark:text-white mb-3'>Frameworks</h3>
                            <div className='flex flex-wrap justify-start items-center gap-3'>
                                {
                                    skillsData.filter(data => data.type === 'framework').map((item, i) =>
                                        <Skill item={item} key={i} />
                                    )
                                }
                            </div>
                        </div>
                        <div className='w-full'>
                            <h3 className='text-2xl font-semibold text-slate-900 dark:text-white mb-3'>UI Frameworks</h3>
                            <div className='flex flex-wrap justify-start items-center gap-3'>
                                {
                                    skillsData.filter(data => data.type === 'ui_framework').map((item, i) =>
                                        <Skill item={item} key={i} />
                                    )
                                }
                            </div>
                        </div>
                        <div className='w-full'>
                            <h3 className='text-2xl font-semibold text-slate-900 dark:text-white mb-3'>Platforms</h3>
                            <div className='flex flex-wrap justify-start items-center gap-3'>
                                {
                                    skillsData.filter(data => data.type === 'platform').map((item, i) =>
                                        <Skill item={item} key={i} />
                                    )
                                }
                            </div>
                        </div>
                        <div className='w-full'>
                            <h3 className='text-2xl font-semibold text-slate-900 dark:text-white mb-3'>Extra</h3>
                            <div className='flex flex-wrap flex-wrap justify-start items-center gap-3'>
                                {
                                    skillsData.filter(data => data.type === 'extra').map((item, i) =>
                                        <Skill item={item} key={i} />
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default Skills